import { OrderItem, OrderItemCreation } from './order-item';
import { PaymentItem } from './payment-item';
import { Refund } from './refund';
import { User } from './user';

export class Order {
  constructor(data) {
    /** @type {number} */
    this.id = data.id;
    this.isAllowAssign = data.isAllowAssign;
    this.userId = data.userId;
    this.isPfsOrder = data.isPfsOrder;
    this.discountCode = data.discountCode;
    this.discountAmount = data.discountAmount;
    this.subTotal = data.subTotal;
    this.tax = data.tax;
    this.createdByUserId = data.createdByUserId;
    this.updatedByUserId = data.updatedByUserId;
    this.total = data.total;
    this.balance = data.balance;
    this.isPaid = data.isPaid;
    this.hasAssignments = data.hasAssignments;
    this.isSelfOrder = data.isSelfOrder;
    this.createdDate = data.createdDate;
    this.editDate = data.editDate;

    /** @type {OrderItem[]} */
    this.items = data.items;

    /** @type {PaymentItem | null} */
    this.payment = data.payment;

    /** @type {User} */
    this.user = data.user;

    /** @type {User} */
    this.createdByUser = data.createdByUser;

    /** @type {User} */
    this.updatedByUser = data.updatedByUser;

    /** @type {Array<{registration_id?: number, registration?: {user?: {first_name?: string, last_name?: string}}}>} */
    this.paymentRegistrations = data.paymentRegistrations ?? data.payment_registrations ?? [];

    /** @type {Array<{first_name: string, last_name: string}>} */
    this.studentNames = data.studentNames ?? [];

    /** @type {Array<{id: number, class_date: string}>} */
    this.classDates = data.classDates ?? [];

    /** @type {Array<{first_name: ?string, last_name: ?string, city: ?string, class_date: ?string, status: string}>} */
    this.studentDetails = data.studentDetails ?? [];
  }
}

export class OrderWithCredentials {
  constructor(data) {
    /** @type {Order} */
    this.order = data.order;
    this.account = {
      username: data.account.username,
      password: data.account.password,
    };
  }
}

export class OrderCreation {
  constructor(data) {
    /** @type {number} */
    this.userId = data.userId;

    /** @type {OrderItemCreation[]} */
    this.items = data.items;
  }
}

export class OrderNonAdminCreation {
  constructor(data) {
    /** @type {number} */
    this.userId = data.userId;

    this.items = data.items;

    /** @type {string[]} */
    this.discounts = data.discount;
  }
}

export class OrderDetail {
  constructor(data) {
    this.id = data.id;

    /** @type {User} */
    this.user = data.user;

    /** @type {Refund[]} */
    this.refunds = data.refunds;
  }
}

export class OrderUpdate {
  constructor(data) {
    this.isAllowAssign = data.isAllowAssign;
    this.isPaid = data.isPaid;
  }
}
